import { render, staticRenderFns } from "./UploadDocumentsTable.vue?vue&type=template&id=ac5e200c&"
import script from "./UploadDocumentsTable.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports